import IconType from "@/types/Icon.type";
import IconPet from "@Icons/searchRes/amenities/IconPet";

/**
 * ticket amenities pets group icon
 * copy of route amenities pet icon
 */
function IconPetsGroup(props: IconType) {
    return (
        <IconPet
            {...props}
        />
    )
}

export default IconPetsGroup;